interface IObjectWithEmptyKeys {
  [paramName: string]: string | number | boolean | undefined;
}

export const replaceNullValuesWithString = <T extends IObjectWithEmptyKeys>(obj: T): IObjectWithEmptyKeys => {
  return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, value === null ? 'null' : value]));
};
